import React, { createContext, useContext } from 'react';

const RolesContext = createContext([]);

export const RolesProvider = ({ children, roles }) => {
    return (
        <RolesContext.Provider value={roles}>
            {children}
        </RolesContext.Provider>
    );
};

export const useRoles = () => {
    return useContext(RolesContext);
};

// Hook utilitaire pour vérifier les permissions
export const useHasRole = (allowedRoles) => {
    const roles = useRoles();
    return roles.some(role => allowedRoles.includes(role));
};